export default function formatClassroomsPostData(classrooms) {
  return classrooms.map(c => {
    const selectedStudents = c.students.filter(s => s.isSelected)
    if (selectedStudents.length === c.students.length) {
      return { id: c.classroom.id, student_ids: [], assign_on_join: true, }
    }
    return { id: c.classroom.id, student_ids: selectedStudents.map(s => s.id), }
  })
}
